// Plantillas de mensaje predeterminadas para el envío de documentos por correo.
// Cada plantilla genera su propio asunto y cuerpo según los documentos seleccionados.

function listaDocs(docs) {
  return docs.map(d => `  • ${d.name} — Versión ${d.version} — ${d.category}`).join("\n");
}

function detalleDoc(d) {
  return `  • Documento: ${d.name}\n  • Versión: ${d.version}\n  • Categoría: ${d.category}\n  • Descripción: ${d.description || "—"}`;
}

export const EMAIL_TEMPLATES = [
  {
    id: "estandar",
    label: "Envío estándar",
    subject: (docs) => docs.length > 1
      ? `[SST] Documentos del Sistema de Gestión — ${docs.length} archivos`
      : `[SST] ${docs[0]?.name} — ${docs[0]?.version}`,
    body: (docs, today) => docs.length > 1
      ? `Estimado(a),\n\nPor medio del presente correo, le remitimos los siguientes documentos del Sistema de Gestión de Seguridad y Salud en el Trabajo (SG-SST):\n\n${listaDocs(docs)}\n\nEstos documentos hacen parte del sistema documental de la organización y se comparten para su conocimiento, revisión y/o implementación según corresponda.\n\nCualquier inquietud, no dude en comunicarse.\n\nAtentamente,\nÁrea de Seguridad y Salud en el Trabajo\nFecha: ${today}`
      : `Estimado(a),\n\nPor medio del presente correo, le remitimos el siguiente documento del Sistema de Gestión de Seguridad y Salud en el Trabajo (SG-SST):\n\n${detalleDoc(docs[0])}\n\nEste documento hace parte del sistema documental de la organización y se comparte para su conocimiento, revisión y/o implementación.\n\nCualquier inquietud, no dude en comunicarse.\n\nAtentamente,\nÁrea de Seguridad y Salud en el Trabajo\nFecha: ${today}`,
  },
  {
    id: "revision",
    label: "Para revisión y aprobación",
    subject: (docs) => docs.length > 1
      ? `[SST] Solicitud de revisión — ${docs.length} documentos`
      : `[SST] Solicitud de revisión — ${docs[0]?.name}`,
    body: (docs, today) => `Estimado(a),\n\nAdjunto ${docs.length > 1 ? "los siguientes documentos" : "el siguiente documento"} del Sistema de Gestión de SG-SST para su revisión y aprobación:\n\n${listaDocs(docs)}\n\nAgradezco revisar el contenido y remitir sus observaciones o confirmación de aprobación a la mayor brevedad posible.\n\nQuedo atento(a) a sus comentarios.\n\nAtentamente,\nÁrea de Seguridad y Salud en el Trabajo\nFecha: ${today}`,
  },
  {
    id: "firma",
    label: "Pendiente de firma",
    subject: (docs) => docs.length > 1
      ? `[SST] Documentos pendientes de firma — ${docs.length} archivos`
      : `[SST] Pendiente de firma — ${docs[0]?.name}`,
    body: (docs, today) => `Estimado(a),\n\nSe remite${docs.length > 1 ? "n" : ""} ${docs.length > 1 ? "los siguientes documentos" : "el siguiente documento"} del Sistema de Gestión de SG-SST, ${docs.length > 1 ? "los cuales requieren" : "el cual requiere"} su firma:\n\n${listaDocs(docs)}\n\nPor favor firmar y remitir de vuelta a este correo a la mayor brevedad, ya que su firma es necesaria para dar continuidad al proceso.\n\nAgradezco su pronta gestión.\n\nAtentamente,\nÁrea de Seguridad y Salud en el Trabajo\nFecha: ${today}`,
  },
  {
    id: "informativo",
    label: "Solo informativo",
    subject: (docs) => docs.length > 1
      ? `[SST] Documentos informativos — ${docs.length} archivos`
      : `[SST] Información — ${docs[0]?.name}`,
    body: (docs, today) => `Estimado(a),\n\nLe compartimos ${docs.length > 1 ? "los siguientes documentos" : "el siguiente documento"} del Sistema de Gestión de Seguridad y Salud en el Trabajo (SG-SST), únicamente para su conocimiento e información:\n\n${listaDocs(docs)}\n\nNo se requiere ninguna acción de su parte.\n\nAtentamente,\nÁrea de Seguridad y Salud en el Trabajo\nFecha: ${today}`,
  },
  {
    id: "actualizacion",
    label: "Actualización de versión",
    subject: (docs) => docs.length > 1
      ? `[SST] Actualización de documentos — ${docs.length} archivos`
      : `[SST] Nueva versión disponible — ${docs[0]?.name}`,
    body: (docs, today) => `Estimado(a),\n\nLe informamos que ${docs.length > 1 ? "los siguientes documentos han sido actualizados" : "el siguiente documento ha sido actualizado"} dentro del Sistema de Gestión de SG-SST:\n\n${listaDocs(docs)}\n\nPor favor descartar versiones anteriores y utilizar en adelante ${docs.length > 1 ? "estas nuevas versiones" : "esta nueva versión"} adjunta${docs.length > 1 ? "s" : ""}.\n\nAtentamente,\nÁrea de Seguridad y Salud en el Trabajo\nFecha: ${today}`,
  },
  {
    id: "personalizado",
    label: "En blanco (personalizado)",
    subject: (docs) => docs.length > 1
      ? `[SST] Documentos del Sistema de Gestión — ${docs.length} archivos`
      : `[SST] ${docs[0]?.name} — ${docs[0]?.version}`,
    body: () => "",
  },
];
